import React, { useState, useEffect } from 'react';
import { retrieveData } from '../apis/dataService';
import axios from 'axios';
import { BackendURL } from '../utils/BackendURL';

export default function AllOrders() {
    const [Orders, setOrders] = useState([]);

    // Function to fetch orders
    const fetchData = async () => {
        try {
            const products = await retrieveData({ api: 'getorders' });
            setOrders(products);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // useEffect with setInterval to auto-refresh every 2 seconds
    useEffect(() => {
        fetchData(); // Initial load

        const intervalId = setInterval(() => {
            fetchData();
        }, 2000);

        return () => clearInterval(intervalId); // Clean up on unmount
    }, []);

    // Function to update order status
    const updateOrderStatus = async (orderId, newStatus) => {
        try {
            const response = await axios.post(`${BackendURL}/update-order-status`, {
                orderId,
                status: newStatus
            });
            console.log('Status updated:', response.data);
            fetchData(); // Refresh data after status update
        } catch (error) {
            console.error('Error updating status:', error);
        }
    };

    // Function to render a single order
    const renderOrder = (order) => (
        <div key={order._id} className="allorder-card">
            <div><strong>Name:</strong> {order.name}</div>
            <div><strong>Email:</strong> {order.email}</div>
            <div><strong>Phone:</strong> {order.phone}</div>
            <div><strong>Status:</strong>
                <select
                    value={order.status}
                    onChange={(e) => updateOrderStatus(order._id, e.target.value)}
                >
                    <option value="email">Pending</option>
                    <option value="shipped">Shipped</option>
                    <option value="delivered">Delivered</option>
                </select>
            </div>
            <div><strong>Address:</strong> {order.address}</div>
            <div><strong>Total:</strong> Rs. {order.TOTAL}</div>

            <div className="allorder-items">
                <strong>Ordered Items:</strong>
                {order.orders && order.orders.length > 0 ? (
                    <ul>
                        {order.orders.map((item, index) => (
                            <li className="allorder-item-li" key={item._id || index}>
                                <div><strong>Name:</strong> {item.imgname}</div>
                                <div><strong>Category:</strong> {item.category}</div>
                                <div><strong>Quantity:</strong> {item.Quantity}</div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No items in this order.</p>
                )}
            </div>
        </div>
    );

    // Categorize orders
    const shippedOrders = Orders.filter(order => order.status === 'shipped');
    const deliveredOrders = Orders.filter(order => order.status === 'delivered');
    const pendingOrders = Orders.filter(order => order.status === 'email' || order.status === "Placed");

    return (
        <div className="AllOrders">
            <div className="AllOrders-title">Orders</div>
            <div className="AllOrders-content">

                <div className="AllOrders-section">
                    <h2>Pending Orders</h2>
                    {pendingOrders.length > 0 ? pendingOrders.map(renderOrder) : <p>No pending orders.</p>}
                </div>

                <div className="AllOrders-section">
                    <h2>Shipped Orders</h2>
                    {shippedOrders.length > 0 ? shippedOrders.map(renderOrder) : <p>No shipped orders.</p>}
                </div>

                <div className="AllOrders-section">
                    <h2>Delivered Orders</h2>
                    {deliveredOrders.length > 0 ? deliveredOrders.map(renderOrder) : <p>No delivered orders.</p>}
                </div>

            </div>
        </div>
    );
}